import React from 'react';
import { ZdsRadio, ZdsRadioGroup } from '@zig-design-system/ui-components-react';
import { Label } from './elements/Label';
export const Radio = ({ field, onChange, value }) => {
    const handleChange = (e) => {
        onChange(field, e.target.value);
    };
    return (React.createElement(ZdsRadioGroup, { required: field.mandatory },
        React.createElement(Label, { field: field }),
        field.modifiedSettings.map((option, index) => (React.createElement(ZdsRadio, { onZdsChange: handleChange, key: `powermail_field_${field.marker}_${index}`, id: `powermail_field_${field.marker}_${index}`, value: option.value, className: field.css === 'horizontal' ? 'zds-inline-block zds-margin-right-6' : undefined, checked: option.value === value },
            React.createElement("span", null, option.label))))));
};
